export var PaymentProcessor;
(function (PaymentProcessor) {
    PaymentProcessor[PaymentProcessor["UNKNOWN"] = 0] = "UNKNOWN";
    PaymentProcessor[PaymentProcessor["STRIPE"] = 1] = "STRIPE";
    PaymentProcessor[PaymentProcessor["AUTHORIZE"] = 2] = "AUTHORIZE";
    PaymentProcessor[PaymentProcessor["TAP"] = 3] = "TAP";
})(PaymentProcessor || (PaymentProcessor = {}));
export var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["UNKNOWN"] = "Unknown";
    PaymentMethodType["OFFLINE"] = "Offline";
    PaymentMethodType["CARD"] = "Card";
    PaymentMethodType["GIFTCARD"] = "GiftCard";
})(PaymentMethodType || (PaymentMethodType = {}));
export var CardFormTitle;
(function (CardFormTitle) {
    CardFormTitle["ADD"] = "Add";
    CardFormTitle["UPDATE"] = "Update";
    CardFormTitle["NONE"] = "";
})(CardFormTitle || (CardFormTitle = {}));
export var CardFormText;
(function (CardFormText) {
    CardFormText["PAYMENT_METHOD"] = "Payment Method";
    CardFormText["PRIMARY_CARD"] = "Primary Card";
    CardFormText["CARDHOLDER_NAME_REQUIRED"] = "Cardholder name is required";
    CardFormText["FIRST_NAME_REQUIRED"] = "First name is required";
    CardFormText["LAST_NAME_REQUIRED"] = "Last name is required";
    CardFormText["IMPROPER_FORMAT"] = "Improper name format";
    CardFormText["SUBMIT"] = "Submit";
    CardFormText["PLEASE_TRY_AGAIN"] = "Please try again";
    CardFormText["YOUR_CARD_WAS_UPDATED"] = "Your payment method was updated successfully!";
    CardFormText["YOUR_CARD_WAS_ADDED"] = "Your payment method was added successfully!";
    CardFormText["UPDATE_LOADING_TEXT"] = "Updating payment method...";
    CardFormText["ADD_LOADING_TEXT"] = "Saving new payment method...";
    CardFormText["UNEXPECTED_ERROR"] = "An unexpected error occurred.";
    CardFormText["ADD_CARD"] = "Add Card";
    CardFormText["UPDATE_CARD"] = "Update";
    CardFormText["PAY_LATER_BUTTON_TEXT"] = "Pay Later";
    CardFormText["PAY_LATER_MODAL_MESSAGE"] = "You Can Also Pay Later. Click Pay Later to continue.";
})(CardFormText || (CardFormText = {}));
export var StatusType;
(function (StatusType) {
    StatusType["IDLE"] = "idle";
    StatusType["ERROR"] = "error";
    StatusType["SUCCEEDED"] = "succeeded";
    StatusType["PROCESSING"] = "processing";
})(StatusType || (StatusType = {}));
